import React, { useState } from "react";
import { service_insurance } from "../../../data/servicesData";

const HomeTabPage = () => {
  const [data] = useState(service_insurance?.home || {});
  return (
    <div className="text-left space-y-6">
      {/* section 1 */}
      <div className="space-y-2">
        {data.overview.map((item, index) => (
          <div key={index}>
            <span>{item}</span>
          </div>
        ))}
      </div>
      {/* section 2 */}
      <div>
        <h1 className="font-bold">{data.title}</h1>
        <p>{data.description}</p>
      </div>
      {/* section 3 */}
      <div className="space-y-2">
        <h1 className="font-bold">{data.covered_title}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.not_covered.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
      {/* section 4 */}
      <div className="space-y-2">
        <h1 className="font-bold">{data.not_covered_title}</h1>
        <div className="ml-8">
          <ul className="list-disc space-y-1">
            {data.not_covered.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HomeTabPage;
